import InfoTooltip from "src/components/general/InfoTooltip/InfoTooltip";
import { usePitToHumanReadable } from "src/hooks/usePitToHumanReadable";
import type { PipelineRun } from "src/queries/pipelines/pipelineRuns.types";

const PitSubtitle = ({
  last_run,
  start_time,
  tooltipTitle,
}: Partial<PipelineRun>) => {
  const pitToHumanReadable = usePitToHumanReadable();
  return (
    <div className="min-w-0 typo-subtitle text-xs truncate flex items-center gap-1">
      {pitToHumanReadable(last_run || start_time, false, {})}
      {(last_run || start_time) && (
        <InfoTooltip size="small" sx={{ height: "15px" }}>
          {tooltipTitle ? tooltipTitle : last_run ? "Last run" : "Start time"}
        </InfoTooltip>
      )}
    </div>
  );
};

export default PitSubtitle;
